import {NativeVideoService} from "./native-video.service";

export const NativeVideoInjectables: Array<any> = [
  {
    provide: NativeVideoService,
    useClass: NativeVideoService,
  },
];
